var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.847,
    height: 15.976
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f79410",
    d: "M25.597 12.938v-.31h-.081l-.093.213-.093-.213h-.081v.31h.057v-.23l.088.2h.059l.087-.2v.234h.057Zm-.512 0v-.257h.1v-.052h-.264v.052h.1v.257h.057Z",
    "data-name": "Path 2178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M16.419 14.268h-6.99V1.708h6.99Z",
    "data-name": "Path 2179"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M9.872 7.988a7.975 7.975 0 0 1 3.051-6.28 7.988 7.988 0 1 0 0 12.56 7.975 7.975 0 0 1-3.051-6.28",
    "data-name": "Path 2180"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M25.847 7.988a7.987 7.987 0 0 1-12.924 6.28 7.988 7.988 0 0 0 0-12.56 7.987 7.987 0 0 1 12.924 6.28",
    "data-name": "Path 2181"
  })));
};
export default SvgMastercard;